
export const evetnModel = {
  id: null,
  uid: null,
  name: null,
  event_date_start: null,
  event_date_finish: null,
  event_type: null,
  location: null,
  event_type_id: null,
  user: { uid: null, email: null },
  timezone_id: null,
  size_guest: 0,
  has_table: false,
  withtablen: 1,
  logo: null,
  has_mailer: false,
  withmailer: 1,
  order_date: null,

  buildata (evetSettings) {
    delete evetSettings.guests
    delete evetSettings.path

    this.id = evetSettings.id
    this.uid = evetSettings.uid
    this.name = evetSettings.name
    this.event_date_start = evetSettings.event_date_start
    this.event_date_finish = evetSettings.event_date_finish
    this.event_type = evetSettings.event_type
    this.timezone_id = evetSettings.timezone.uid
    this.has_table = evetSettings.has_table
    this.has_mailer = evetSettings.has_mailer
    this.location = evetSettings.location
    this.size_guest = evetSettings.size_guest
    this.order_date = this.toIsoDate(evetSettings.order_date)

    if (this.has_table) {
      this.withtablen = 0
    }

    if (this.has_mailer) {
      this.withmailer = 0
    }

    // Assicurati che gli ID per le select siano impostati correttamente
    if (this.event_type) {
      this.event_type_id = evetSettings.event_type.id
    }
    if (this.timezone) {
      this.timezone_id = evetSettings.timezone.uid
    }
  },

  toIsoDate (dateStr) {
    if (!dateStr) return null

    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      return dateStr
    }

    const match = dateStr.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
    if (!match) return null

    let [, day, month, year] = match
    day = day.padStart(2, '0')
    month = month.padStart(2, '0')

    return `${year}-${month}-${day}`
  },

  formatLocalISO (date) {
    const d = new Date(date)
    const tzOffset = d.getTimezoneOffset() * 60000
    this.order_date = new Date(d - tzOffset).toISOString().slice(0, 10)
  }

}
